import { PublicKey } from '@solana/web3.js';
import { ethers } from 'ethers';
import { Address } from '@ton/core';


// Telegram Cloud Storage Utility Functions
export const shortWalletAddress = async (address: string): Promise<string> => {
		if (address) {
			if (address.length <= 10) {
				return address;
			}

			const start = address.slice(0, 10);
			const end = address.slice(-10);

			return `${start}...${end}`;
		}
		else {
            return ``
        }
};

/**
 * 비동기 sleep 함수
 * @param ms 
 * @returns 
 */
export const sleep = (ms: number): Promise<void> => {
	return new Promise(resolve => setTimeout(resolve, ms));
};
/**
 * nft 블록 익스플로러 url
 * @param chainName 
 * @param address 
 */
export const getNftBlockScanUrl = async (network: string, contractAddress:string, tokenId: string): Promise<string> => {
	
	if(process.env.REACT_APP_SOLANA_NETWORK_NAME?.toLowerCase() === network.toLowerCase()) {
		return ``;
	} else if (process.env.REACT_APP_BSC_NETWORK_NAME?.toLowerCase() === network.toLowerCase()) {
		return `${process.env.REACT_APP_NETWORK_SCAN_URL}/token/${contractAddress}/instance/${tokenId}`
	} else {
		return ``;
	}

}